
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/search",
      function () {
        return require("private-next-pages/stores/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/search"])
      });
    }
  